import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ordersAPI, productsAPI } from '../../utils/api';
import { LoadingSpinner } from '../../components/common';

const StatCard = ({ icon, label, value, color = '#2563eb' }) => (
  <div className="card flex-center" style={{ gap: '1rem' }}>
    <div style={{ fontSize: '2.2rem', background: color + '20', padding: '0.75rem', borderRadius: 10 }}>{icon}</div>
    <div>
      <div style={{ fontSize: '0.8rem', color: '#6b7280', fontWeight: 600 }}>{label}</div>
      <div style={{ fontSize: '1.6rem', fontWeight: 900, color }}>{value}</div>
    </div>
  </div>
);

const AdminDashboard = () => {
  const [stats, setStats] = useState(null);
  const [lowStock, setLowStock] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      ordersAPI.dashboard(),
      productsAPI.getLowStock(),
    ]).then(([statsRes, stockRes]) => {
      setStats(statsRes.data);
      setLowStock(stockRes.data.slice(0, 5));
    }).finally(() => setLoading(false));
  }, []);

  if (loading) return <LoadingSpinner />;

  return (
    <div>
      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <h1>Dashboard</h1>
          <p>Welcome back, Admin!</p>
        </div>
        <div className="flex gap-2">
          <Link to="/admin/orders" className="btn btn-outline btn-sm">View Orders</Link>
          <Link to="/admin/products" className="btn btn-primary btn-sm">+ Add Product</Link>
        </div>
      </div>

      {/* Stats */}
      <div className="grid-4" style={{ marginBottom: '1.5rem' }}>
        <StatCard icon="📦" label="Total Orders" value={stats?.total_orders || 0} color="#2563eb" />
        <StatCard icon="💰" label="Revenue" value={`$${parseFloat(stats?.total_revenue || 0).toFixed(0)}`} color="#10b981" />
        <StatCard icon="⏳" label="Pending Orders" value={stats?.pending_orders || 0} color="#f59e0b" />
        <StatCard icon="⚠️" label="Low Stock Items" value={stats?.low_stock_count || 0} color="#ef4444" />
      </div>

      <div className="grid-2">
        {/* Top Products */}
        <div className="card">
          <h2 style={{ fontWeight: 700, marginBottom: '1rem' }}>Top Selling Products</h2>
          {stats?.top_products?.length > 0 ? stats.top_products.map((p, i) => (
            <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '0.5rem 0', borderBottom: '1px solid #f3f4f6', fontSize: '0.88rem' }}>
              <span>#{i + 1} {p.name}</span>
              <span style={{ fontWeight: 700, color: '#2563eb' }}>{p.sold} sold</span>
            </div>
          )) : <p className="text-muted text-sm">No sales data yet</p>}
        </div>

        {/* Low Stock Alert */}
        <div className="card">
          <h2 style={{ fontWeight: 700, marginBottom: '1rem' }}>⚠️ Low Stock Alerts</h2>
          {lowStock.length > 0 ? lowStock.map(p => (
            <div key={p.id} style={{ display: 'flex', justifyContent: 'space-between', padding: '0.5rem 0', borderBottom: '1px solid #f3f4f6', fontSize: '0.88rem', alignItems: 'center' }}>
              <span>{p.name}</span>
              <span className={`badge ${p.stock_qty === 0 ? 'badge-danger' : 'badge-warning'}`}>
                {p.stock_qty === 0 ? 'Out of Stock' : `${p.stock_qty} left`}
              </span>
            </div>
          )) : <p className="text-muted text-sm">All products well-stocked ✓</p>}
          <Link to="/admin/products" className="btn btn-outline btn-sm btn-full" style={{ marginTop: '0.75rem' }}>
            Manage Inventory
          </Link>
        </div>
      </div>

      {/* Quick Links */}
      <div className="card" style={{ marginTop: '1rem' }}>
        <h2 style={{ fontWeight: 700, marginBottom: '1rem' }}>Quick Actions</h2>
        <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
          {[
            { label: '🏫 Manage Schools', path: '/admin/schools' },
            { label: '🎒 Manage Kits', path: '/admin/kits' },
            { label: '📦 Manage Products', path: '/admin/products' },
            { label: '📁 Categories', path: '/admin/categories' },
            { label: '🧾 Orders', path: '/admin/orders' },
          ].map(l => (
            <Link key={l.path} to={l.path} className="btn btn-outline">{l.label}</Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
